import log from "../../../../utils/logger/library";

export const turnOnError = new Error("Failed to turn on ReadJS");

const CMS = {
    cms: "polopoly",
};

export const READJS_STORY_TRACKING = {
    el: ".story",
    spa: true,
    strict: false,
    thresholds: {
        domNode: 100,
        domPolling: 100,
        maxTimeInView: 20,
        minTimeInView: 3,
        readingPoint: 400,
        scrollDepth: 30,
        viewport: 15,
    },
    activity: {
        scrollDepth: 30,
        increment: 100,
        averageReadSpeed: 5,
    },
    debug: {
        overlay: false,
        console: false,
    },
    timeInterval: 1.5,
};

/**
 * @param url {string} story url
 * @param type {string} story type
 * @param id {string} story id
 * @param title {string} headline of the story
 * @param pubdate {number} epoch publish time
 *
 * @return {object} return object form of the params
 */
export const contentFactory = (url, type, id, title, pubdate) => {
    return {
        url,
        type,
        id,
        title,
        pubdate,
    };
};

/**
 * @param content {object} contentFactory object
 *
 * @return void
 */
export const trackEvent = (content) => {
    content = Object.assign({}, CMS, content);
    try {
        window.CBC.APP.SC.EventTracker.trackEvent("READ", { content });
    } catch (error) {
        log.error("(trackEvent)", new Error("Failed to track READ event"));
    }
};

/**
 *
 * @param content {object} contentFactory object
 * @param callnack {function} called when article read
 *
 * @return Promise<void>
 */

export const turnOn = (content, callback) => {
    const cb = () => {
        trackEvent(content);
        typeof callback === "function" && callback();
    };
    window.readJSConfig = Object.assign({ cb }, READJS_STORY_TRACKING);
    return import("read-js").then(() => {
        if (!window.readJS.isOn() && !window.readJS.turnOn()) {
            throw turnOnError;
        }
    });
};

/**
 * @return void
 */

export const turnOff = () => {
    try {
        window.readJS.turnOff();
    } catch (error) {
        log.error("(turnOff)", new Error("Failed to turn off ReadJS"));
    }
};
